import { NgModule } from '@angular/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { CoreModule } from '../core/core.module';
import { FooterComponent } from './component/footer/footer.component';
import { HeaderComponent } from './component/header/header.component';
import { ProfilePopoverComponent } from './component/profile-popover/profile-popover.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

import 'froala-editor/js/plugins.pkgd.min.js';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { MediaLibraryComponent } from './modal/media-library/media-library.component';
import { AddImageComponent } from './component/add-image/add-image.component';
import { ImagePreviewComponent } from './component/image-preview/image-preview.component';
import { CategorySideMenuComponent } from './component/category-side-menu/category-side-menu.component';
import { RouterModule } from '@angular/router';
import { MembersPricingComponent } from './component/members-pricing/members-pricing.component'
import { AssociateSurveyComponent } from './component/associate-survey/associate-survey.component';
import { ImageSliderComponent } from './component/image-slider/image-slider.component';
import { CheckoutButtonComponent } from './component/checkout-button/checkout-button.component';
import { ExpressBankingComponent } from './component/express-banking/express-banking.component';
import { UserLookupComponent } from './component/user-lookup/user-lookup.component';
import { CalendarComponent } from './component/calendar/calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';

import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SlugCheckerComponent } from './component/slug-checker/slug-checker.component';
import { AiHelperComponent } from './modal/ai-helper/ai-helper.component';
import { ExpressBankingPayoutComponent } from './component/express-banking-payout/express-banking-payout.component';
import { OrderDetailsComponent } from './component/order-details/order-details.component';
import { InstructionComponent } from './component/instruction/instruction.component';
import { PageCountsComponent } from './component/page-counts/page-counts.component';
import { HelpBubbleComponent } from './component/help-bubble/help-bubble.component';
import { PromoteOverviewComponent } from './component/promote-overview/promote-overview.component';
import { TextOrHtmlComponent } from './component/text-or-html/text-or-html.component';
import { MultiSelectListComponent } from './component/multi-select/multi-select-list/multi-select-list.component';
import { MultiSelectComponent } from './component/multi-select/multi-select.component';
import { MultiSelectDirective } from './component/multi-select/multi-select.directive';
import { MigrateAuctionComponent } from './component/migrate-auction/migrate-auction.component';
import { OverviewTitleComponent } from './component/overview-title/overview-title.component';
import { DateFilterComponent } from './component/date-filter/date-filter.component';
import { SelectPurchaserComponent } from './component/select-purchaser/select-purchaser.component';
import { SpecialProductQuantityComponent } from './component/special-product-quantity/special-product-quantity.component';
import { HtmlEditorModal } from './modal/html-editor/html-editor.component';
import { ContentMenuNewComponent } from './component/content-menu/content-menu.component';
import { PageSelectorComponent } from './component/page-selector/page-selector.component';
import { HtmlContentPage } from './modal/html-content/html-content.page';
import { SurveyQuestionsBuilderComponent } from './component/survey-questions-builder/survey-questions-builder.component';

@NgModule({
  declarations: [
    // modals
    MediaLibraryComponent,
    HtmlEditorModal,

    // components
    AddImageComponent,
    AiHelperComponent,
    CalendarComponent,
    CategorySideMenuComponent,
    ContentMenuNewComponent,
    DateFilterComponent,
    FooterComponent,
    HeaderComponent,
    HelpBubbleComponent,
    ImagePreviewComponent,
    ImageSliderComponent,
    InstructionComponent,
    PageCountsComponent,
    PageSelectorComponent,
    ProfilePopoverComponent,
    PromoteOverviewComponent,
    TextOrHtmlComponent,
    MembersPricingComponent,
    AssociateSurveyComponent,
    CheckoutButtonComponent,
    ExpressBankingComponent,
    ExpressBankingPayoutComponent,
    UserLookupComponent,
    SelectPurchaserComponent,
    SlugCheckerComponent,
    OrderDetailsComponent,
    MultiSelectDirective,
    MultiSelectComponent,
    MultiSelectListComponent,
    MigrateAuctionComponent,
    OverviewTitleComponent,
    SpecialProductQuantityComponent,
    SurveyQuestionsBuilderComponent,
    HtmlContentPage,
  ],
  imports: [
    CoreModule,
    RouterModule,
    ColorPickerModule,
    DragDropModule,
    FroalaEditorModule,
    FroalaViewModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  exports: [
    AddImageComponent,
    AiHelperComponent,
    CalendarComponent,
    CategorySideMenuComponent,
    ContentMenuNewComponent,
    DateFilterComponent,
    FooterComponent,
    HeaderComponent,
    HelpBubbleComponent,
    ImagePreviewComponent,
    ImageSliderComponent,
    InstructionComponent,
    PageCountsComponent,
    PromoteOverviewComponent,
    FroalaEditorModule,
    FroalaViewModule,
    PageSelectorComponent,
    MembersPricingComponent,
    CheckoutButtonComponent,
    ExpressBankingPayoutComponent,
    ExpressBankingComponent,
    UserLookupComponent,
    SelectPurchaserComponent,
    SlugCheckerComponent,
    OrderDetailsComponent,
    MultiSelectDirective,
    MultiSelectComponent,
    MultiSelectListComponent,
    MigrateAuctionComponent,
    OverviewTitleComponent,
    SpecialProductQuantityComponent,
    SurveyQuestionsBuilderComponent,
    TextOrHtmlComponent,
    AssociateSurveyComponent,
  ],
  providers: [
  ]
})
export class SharedModule { }
